import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { usePageMeta } from '@/hooks/usePageMeta';

export default function Datenschutz() {
  usePageMeta({ noIndex: true });

  return (
    <main className="font-sans bg-white min-h-screen">
      <Navbar />

      <div className="max-w-3xl mx-auto px-4 md:px-8 pt-32 pb-20">

        {/* Back link */}
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 text-sm text-charcoal/50 hover:text-rose transition-colors duration-200 cursor-pointer mb-10"
        >
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-left-line text-sm" />
          </span>
          Zurück zur Startseite
        </Link>

        <h1 className="font-serif text-4xl md:text-5xl font-medium text-charcoal mb-2">
          Datenschutzerklärung
        </h1>
        <p className="font-sans text-sm text-charcoal/40 mb-10">
          Informationen gemäß DSGVO (EU) 2016/679
        </p>

        <div className="space-y-10 text-charcoal">

          {/* 1. Verantwortliche Stelle */}
          <section>
            <h2 className="font-sans text-lg font-semibold text-charcoal mb-3">
              1. Verantwortliche Stelle
            </h2>
            <div className="font-sans text-base text-charcoal/80 leading-[1.9] space-y-2">
              <p>
                Verantwortlich für die Verarbeitung personenbezogener Daten auf
                dieser Website ist:
              </p>
              <div className="space-y-0.5">
                <p><strong>Jenny [Nachname]</strong></p>
                <p>Flow &amp; Glow — Kosmetische Zahnaufhellung</p>
                <p>[Adresse] — [PLZ] Köln</p>
                <p>
                  E-Mail:{' '}
                  <a
                    href="mailto:hallo@flowundglow.de"
                    className="text-rose hover:underline cursor-pointer"
                  >
                    hallo@flowundglow.de
                  </a>
                </p>
              </div>
            </div>
          </section>

          <div className="border-t border-charcoal/8" />

          {/* 2. Erhebung */}
          <section>
            <h2 className="font-sans text-lg font-semibold text-charcoal mb-3">
              2. Erhebung und Speicherung personenbezogener Daten
            </h2>
            <div className="font-sans text-base text-charcoal/80 leading-[1.9] space-y-3">
              <p>
                Beim Besuch dieser Website werden durch den Hosting-Anbieter
                automatisch folgende Informationen erfasst und in sogenannten
                Server-Log-Dateien gespeichert:
              </p>
              <ul className="list-none space-y-1.5 pl-4">
                {[
                  'IP-Adresse des anfragenden Rechners (anonymisiert)',
                  'Datum und Uhrzeit des Zugriffs',
                  'Name und URL der abgerufenen Datei',
                  'Website, von der aus der Zugriff erfolgt (Referrer-URL)',
                  'Verwendeter Browser und ggf. das Betriebssystem',
                ].map((item) => (
                  <li key={item} className="flex items-start gap-2">
                    <span className="w-4 h-4 flex items-center justify-center mt-1 flex-shrink-0">
                      <i className="ri-subtract-line text-rose/60 text-xs" />
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
              <p>
                Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f
                DSGVO (berechtigtes Interesse an der sicheren und
                funktionsfähigen Darstellung der Website). Eine Zusammenführung
                dieser Daten mit anderen Datenquellen findet nicht statt.
              </p>
            </div>
          </section>

          <div className="border-t border-charcoal/8" />

          {/* 3. Cookies */}
          <section>
            <h2 className="font-sans text-lg font-semibold text-charcoal mb-3">
              3. Cookies
            </h2>
            <div className="font-sans text-base text-charcoal/80 leading-[1.9] space-y-3">
              <p>
                Diese Website verwendet technisch notwendige Cookies, die für den
                Betrieb der Website erforderlich sind. Diese Cookies enthalten
                keine personenbezogenen Daten und werden nicht zu Tracking- oder
                Werbezwecken eingesetzt.
              </p>
              <p>
                Technisch notwendige Cookies können nicht deaktiviert werden, da
                die Website ohne sie nicht ordnungsgemäß funktionieren würde.
                Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO.
              </p>
              <p>
                Soweit auf dieser Website Dienste Dritter (z. B. Buchungssystem
                SimplyBook.me / Calendly) eingebettet werden, können durch diese
                Anbieter eigene Cookies gesetzt werden. Bitte beachten Sie
                hierzu die Datenschutzerklärungen der jeweiligen Anbieter.
              </p>
            </div>
          </section>

          <div className="border-t border-charcoal/8" />

          {/* 4. Buchungssystem */}
          <section>
            <h2 className="font-sans text-lg font-semibold text-charcoal mb-3">
              4. Online-Buchungssystem
            </h2>
            <div className="font-sans text-base text-charcoal/80 leading-[1.9] space-y-3">
              <p>
                Für die Terminbuchung wird ein externes Buchungssystem
                (SimplyBook.me oder Calendly) eingesetzt. Bei der Nutzung werden
                folgende Daten erhoben und an den jeweiligen Anbieter übermittelt:
              </p>
              <ul className="list-none space-y-1.5 pl-4">
                {[
                  'Vor- und Nachname',
                  'E-Mail-Adresse',
                  'Telefonnummer (optional)',
                  'Gewünschte Anwendung und Wunschdatum',
                ].map((item) => (
                  <li key={item} className="flex items-start gap-2">
                    <span className="w-4 h-4 flex items-center justify-center mt-1 flex-shrink-0">
                      <i className="ri-subtract-line text-rose/60 text-xs" />
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
              <p>
                Die Verarbeitung dieser Daten ist für die Vertragsanbahnung
                erforderlich (Art. 6 Abs. 1 lit. b DSGVO). Die Daten werden
                ausschließlich zur Terminverwaltung verwendet und nicht an Dritte
                weitergegeben. Informationen zur Datenverarbeitung durch den
                Buchungsanbieter entnehmen Sie bitte dessen Datenschutzerklärung.
              </p>
            </div>
          </section>

          <div className="border-t border-charcoal/8" />

          {/* 5. Kontakt */}
          <section>
            <h2 className="font-sans text-lg font-semibold text-charcoal mb-3">
              5. Kontaktaufnahme (E-Mail / WhatsApp)
            </h2>
            <div className="font-sans text-base text-charcoal/80 leading-[1.9] space-y-3">
              <p>
                Wenn Sie per E-Mail oder WhatsApp Kontakt aufnehmen, werden Ihre
                übermittelten Daten (Name, E-Mail-Adresse, Nachrichteninhalt)
                gespeichert und ausschließlich zur Bearbeitung Ihrer Anfrage
                verwendet.
              </p>
              <p>
                Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes
                Interesse an der Beantwortung von Anfragen) bzw. Art. 6 Abs. 1
                lit. b DSGVO, soweit die Anfrage auf den Abschluss eines Vertrages
                gerichtet ist. Die Daten werden nach vollständiger Bearbeitung
                gelöscht, sofern keine gesetzlichen Aufbewahrungspflichten
                entgegenstehen.
              </p>
            </div>
          </section>

          <div className="border-t border-charcoal/8" />

          {/* 6. Rechte */}
          <section>
            <h2 className="font-sans text-lg font-semibold text-charcoal mb-3">
              6. Rechte der betroffenen Personen
            </h2>
            <div className="font-sans text-base text-charcoal/80 leading-[1.9] space-y-3">
              <p>
                Sie haben gemäß DSGVO gegenüber uns folgende Rechte hinsichtlich
                der Sie betreffenden personenbezogenen Daten:
              </p>
              <ul className="list-none space-y-2 pl-4">
                {[
                  { right: 'Recht auf Auskunft', desc: 'Sie können Auskunft über Ihre gespeicherten Daten verlangen (Art. 15 DSGVO).' },
                  { right: 'Recht auf Berichtigung', desc: 'Sie können die Berichtigung unrichtiger Daten verlangen (Art. 16 DSGVO).' },
                  { right: 'Recht auf Löschung', desc: 'Sie können die Löschung Ihrer Daten verlangen, sofern keine gesetzlichen Aufbewahrungspflichten entgegenstehen (Art. 17 DSGVO).' },
                  { right: 'Recht auf Einschränkung', desc: 'Sie können die Einschränkung der Verarbeitung Ihrer Daten verlangen (Art. 18 DSGVO).' },
                  { right: 'Recht auf Datenübertragbarkeit', desc: 'Sie können Ihre Daten in einem maschinenlesbaren Format herausverlangen (Art. 20 DSGVO).' },
                  { right: 'Widerspruchsrecht', desc: 'Sie können der Verarbeitung Ihrer Daten auf Basis berechtigter Interessen jederzeit widersprechen (Art. 21 DSGVO).' },
                ].map((item) => (
                  <li key={item.right} className="flex items-start gap-2">
                    <span className="w-4 h-4 flex items-center justify-center mt-1 flex-shrink-0">
                      <i className="ri-subtract-line text-rose/60 text-xs" />
                    </span>
                    <span>
                      <strong>{item.right}:</strong> {item.desc}
                    </span>
                  </li>
                ))}
              </ul>
              <p>
                Zur Geltendmachung Ihrer Rechte wenden Sie sich bitte an:{' '}
                <a
                  href="mailto:hallo@flowundglow.de"
                  className="text-rose hover:underline cursor-pointer"
                >
                  hallo@flowundglow.de
                </a>
              </p>
            </div>
          </section>

          <div className="border-t border-charcoal/8" />

          {/* 7. Widerrufsrecht */}
          <section>
            <h2 className="font-sans text-lg font-semibold text-charcoal mb-3">
              7. Widerrufsrecht bei einwilligungsbasierter Verarbeitung
            </h2>
            <div className="font-sans text-base text-charcoal/80 leading-[1.9] space-y-3">
              <p>
                Sofern die Verarbeitung Ihrer personenbezogenen Daten auf einer
                Einwilligung beruht (Art. 6 Abs. 1 lit. a DSGVO), haben Sie das
                Recht, diese Einwilligung jederzeit mit Wirkung für die Zukunft
                zu widerrufen. Die Rechtmäßigkeit der bis zum Widerruf erfolgten
                Verarbeitung bleibt davon unberührt.
              </p>
              <p>
                Den Widerruf können Sie formlos per E-Mail an{' '}
                <a
                  href="mailto:hallo@flowundglow.de"
                  className="text-rose hover:underline cursor-pointer"
                >
                  hallo@flowundglow.de
                </a>{' '}
                senden.
              </p>
            </div>
          </section>

          <div className="border-t border-charcoal/8" />

          {/* 8. Beschwerderecht */}
          <section>
            <h2 className="font-sans text-lg font-semibold text-charcoal mb-3">
              8. Beschwerderecht bei der Aufsichtsbehörde
            </h2>
            <div className="font-sans text-base text-charcoal/80 leading-[1.9]">
              <p>
                Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde
                über die Verarbeitung Ihrer personenbezogenen Daten zu beschweren.
                Zuständige Aufsichtsbehörde für Nordrhein-Westfalen ist:
              </p>
              <div className="mt-3 pl-4 border-l-2 border-rose/20 space-y-0.5">
                <p className="font-medium">Landesbeauftragte für Datenschutz und Informationsfreiheit NRW</p>
                <p>Kavalleriestraße 2–4</p>
                <p>40213 Düsseldorf</p>
                <p>
                  Web:{' '}
                  <a
                    href="https://www.ldi.nrw.de"
                    target="_blank"
                    rel="nofollow noreferrer"
                    className="text-rose hover:underline cursor-pointer"
                  >
                    www.ldi.nrw.de
                  </a>
                </p>
              </div>
            </div>
          </section>

          <div className="border-t border-charcoal/8" />

          <p className="font-sans text-xs text-charcoal/35 pt-2">
            Stand: April 2026 · Diese Datenschutzerklärung wird bei Bedarf aktualisiert.
          </p>
        </div>
      </div>

      <Footer />
    </main>
  );
}
